import type { ReactNode } from 'react';
import { isTenantAdminUser, useAuthStore } from '@store/authStore';

interface AdminRouteProps {
  children: ReactNode;
  requiredPermission?: string | string[];
  fallbackMessage?: string;
}

export const AdminRoute = ({
  children,
  requiredPermission,
  fallbackMessage = 'You do not have permission to access this page.',
}: AdminRouteProps) => {
  const currentUser = useAuthStore((state) => state.currentUser);
  const hasPermission = useAuthStore((state) => state.hasPermission);

  const requiredPermissions = Array.isArray(requiredPermission)
    ? requiredPermission
    : requiredPermission
      ? [requiredPermission]
      : [];
  const tenantAdmin = isTenantAdminUser(currentUser);

  const isAllowed = requiredPermissions.length === 0
    ? tenantAdmin
    : tenantAdmin || requiredPermissions.some((permission) => hasPermission(permission));

  if (!isAllowed) {
    return (
      <div className="text-center py-12">
        <h1 className="text-2xl font-bold text-content-primary mb-2">
          Access Denied
        </h1>
        <p className="text-content-secondary">
          {fallbackMessage}
        </p>
      </div>
    );
  }

  return <>{children}</>;
};
